// ============================================================
// CaseStatusFilter.tsx — the case list's Status dropdown.
// All statuses / Draft / Open / Closed, then — below a thin divider, only
// when there's at least one — "No limitation date (N)": open and draft cases
// with no limitation-type deadline (utils/missingLimitation). N is the case
// list's count for its current assignee filter (CaseListScreen). The option
// also stays while it's the selected one (e.g. a link opened it and N is now
// 0), so the dropdown never shows a value it doesn't list. When the count
// isn't known (its request failed) the option shows no number, rather than a
// wrong "(0)" over a list that has rows.
// ============================================================
import React from 'react'

export type CaseStatusValue = 'all' | 'draft' | 'open' | 'closed' | 'nolimitation'

const CaseStatusFilter: React.FC<{
  value: CaseStatusValue
  noLimitationCount: number | null
  onChange: (v: CaseStatusValue) => void
  className?: string
}> = ({ value, noLimitationCount, onChange, className }) => {
  const showNoLim = (noLimitationCount ?? 0) > 0 || value === 'nolimitation'
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as CaseStatusValue)}
      aria-label="Filter by status"
      className={className}
    >
      <option value="all">All statuses</option>
      <option value="draft">Draft</option>
      <option value="open">Open</option>
      <option value="closed">Closed</option>
      {showNoLim && (
        <>
          {/* The thin divider (a native <select> can't hold an <hr> in every browser). */}
          <option disabled aria-hidden="true" value="">──────────</option>
          <option value="nolimitation">{noLimitationCount === null ? 'No limitation date' : `No limitation date (${noLimitationCount})`}</option>
        </>
      )}
    </select>
  )
}

export default CaseStatusFilter
